"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = makeStyles_1.default((theme) => ({
    radioRoot: {
        padding: 2,
    },
    labelLabel: {
        fontSize: 14,
        marginLeft: 5,
    },
    labelRoot: {
        height: 25,
        /** to make radio buttons smaller */
        '& svg': {
            height: 18,
            width: 18,
        },
    },
    radioControl: {
        margin: 0,
    },
    disabled: {
        backgroundColor: 'inherit',
    },
    highlightedIcon: {
        backgroundColor: `${theme.palette.editing} !important`,
    },
}));
//# sourceMappingURL=radio-group-styles.js.map